import { render } from "./InputSelect.vue?vue&type=template&id=b5dfa1ec&scoped=true&ts=true"
import script from "./InputSelect.vue?vue&type=script&lang=ts"
export * from "./InputSelect.vue?vue&type=script&lang=ts"

import "./InputSelect.vue?vue&type=style&index=0&id=b5dfa1ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5dfa1ec"]])

export default __exports__